import LoadingDot from "components/LoadingDot";
import styles from "components/sections/search/LoadingSearchResult.module.scss";
import ErrorIcon from "images/icons/alert_circle.svg";
import FullButton from "components/buttons/FullButton";
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';

const LoadingSearchResult = () => {
    return (
        <div className={styles.container}>
            <LoadingDot width={107} height={107} />
        </div>
    );
};

export default LoadingSearchResult;

export const SearchResultError = (props) => {
    const {handleRefresh} = props;
    const {t} = useTranslation('sections-search-LoadingSearchResult');

    return (
        <div className={styles.container} style={{paddingTop: 220}}>
            <div className={styles.errorContainer}>
                <ErrorIcon />
                <div className={styles.errorText}>
                    <Trans
                        i18nKey="sections-search-LoadingSearchResult:SearchResultError.networkError"
                    /><br/>
                    {t('SearchResultError.checkConnection')}
                </div>
                <div className={styles.buttonContainer} onClick={handleRefresh}>
                    <FullButton height={40}>
                        <span className={styles.buttonText}>{t('SearchResultError.retryButton')}</span>
                    </FullButton>
                </div>
            </div>
        </div>
    );
}
